import { render, staticRenderFns } from "./modal-info.vue?vue&type=template&id=61361ebe&"
import script from "./modal-info.vue?vue&type=script&lang=js&"
export * from "./modal-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports